export class AdcValue{
  ioType: string = '';
  index: number | undefined;
  hysteresis: number = 0;
  name: string = '';
  scaleMin: number = 0;
  scaleMax: number = 0;
}